import ShopCartContainer from './ShopCartContainer';

export default ShopCartContainer;
